<template>
    <v-app>
        <div class="app">
            <div class="sidebar-wrapper">
                <sidebar />
            </div>
            <div class="main">
                <home />
                <about />
                <technologies />
                <contact />
            </div>
            <div class="sidebar-button-wrapper">
                <v-btn
                    class="sidebar-button"
                    fab
                    color="rgba(0,0,0,0.65)"
                    @click="sidebarViewChange"
                >
                    <v-icon>mdi-menu</v-icon>
                </v-btn>
            </div>
            <v-expand-x-transition>
                <div class="sidebar-wrapper-mobile">
                    <sidebar :temporary="true" :view="sidebarOpened" @mobile-sidebar-closed="sidebarViewChange" @change="sidebarViewChange" />
                </div>
            </v-expand-x-transition>
        </div>
    </v-app>
</template>

<script>
    import Sidebar from '@/components/Sidebar'
    import About from '@/components/About'
    import Contact from '@/components/Contact'
    import Home from '@/components/Home'
    import Technologies from '@/components/Technologies'

    export default {
        name: 'App',
        components: {
            About, Contact, Technologies, Sidebar, Home
        },
        data() {
            return {
                sidebarOpened: false,
                route: 'home'
            }
        },
        created() {
            document.title = 'Karageorgos Dimitris | Software Engineer'
        },
        methods: {
            sidebarViewChange() {
                this.sidebarOpened = !this.sidebarOpened
            }
        }
    }
</script>

<style scoped>

.app {
    display: flex;
}

.main {
    width: 100%;
    height: 100%;
    margin-left: max(200px, 17%);
}

.sidebar-button-wrapper {
    width: 50px;
    height: 50px;
    position: fixed;
    right: 3%;
    top: 2%;
}

.v-icon {
    color: white !important;
}

@media screen and (max-width: 768px) {
    .sidebar-wrapper {
        display: none
    }

    .main {
        width: 100vw;
        margin-left: 0;
    }
}

@media screen and (min-width: 768px) {
    .sidebar-button-wrapper {
        display: none;
    }

    .sidebar-wrapper-mobile {
        display: none;
    }
}

@font-face {
    font-family: "Poppins-Bold";
    src:
        url("~@/assets/fonts/Poppins-Bold.ttf") format("trueType")
}

@font-face {
    font-family: "Poppins-Bold-Italic";
    src:
        url("~@/assets/fonts/Poppins-BoldItalic.ttf") format("trueType")
}

@font-face {
    font-family: "Poppins";
    src:
        url("~@/assets/fonts/Poppins-Regular.ttf") format("trueType")
}
</style>
